import { smallLogo } from "../../../assets";
import { Scrollbars } from "react-custom-scrollbars-2";
import { getTimeGap, getIgnitionStatus } from "../utils";
import { useRef, useMemo, useEffect } from "react";

export const VehicleDetailsWindowView = ({
  realTimedata,
  deviceId,
  deviceData,
  summaryDetails,
  listDetails,
  selectedVehiclePlate,
  type,
}) => {
  const latestDataRef = useRef(null);

  useEffect(() => {
    latestDataRef.current = null;
  }, [selectedVehiclePlate, deviceId]);

  const realTimeDataSource = useMemo(() => {
    const currentData =
      type === "Vehicles" ? realTimedata[selectedVehiclePlate] : realTimedata[deviceId];
    const identifier = type === "Vehicles" ? selectedVehiclePlate : deviceId;

    if (currentData && latestDataRef.current?.identifier === identifier) {
      latestDataRef.current = { ...currentData, identifier };
    } else if (currentData) {
      latestDataRef.current = { ...currentData, identifier };
    }

    return latestDataRef.current;
  }, [type, realTimedata, selectedVehiclePlate, deviceId]);

  const { status, description } = getTimeGap(
    realTimeDataSource?.source_time ?? deviceData?.source_time
  );

  return (
    <article className="device-details-window">
      <section className="details-block_section">
        <aside className="details-block_summary">
          <div className="details-block_summary_item-info">
            <div className="item-photo">
              <img src={smallLogo} alt="logo" />
              <span className={`status ${status}`} title={description}></span>
            </div>
          </div>
          <ul className="details-block_summary_list">{summaryDetails}</ul>
        </aside>
        <div className="details-block_data-container-wrapper">{listDetails}</div>
      </section>
    </article>
  );
};
